import { cva, cx, VariantProps } from 'class-variance-authority';
import { forwardRef } from 'react';
import { Typography, TypographyProps } from './Typography';
import { BaseTypeMap, Component, ComponentProps } from './types/Component';

const link = cva(['hover:underline', 'cursor-pointer', 'text-inherit'], {
  variants: {
    color: {
      inherit: ['text-inherit'],
      default: [
        'text-primary-600',
        'active:text-primary:700',
        'focus:text-primary-700',
        'hover:text-primary-700',
      ],
    },
    full: {
      true: ['z-[1]', 'after:content-[" "]', 'after:absolute', 'after:inset-0'],
      false: [],
    },
    underline: {
      true: ['underline', 'hover:no-underline'],
      false: [],
    },
  },
  defaultVariants: {
    color: 'default',
  },
});

type Link = BaseTypeMap<
  'a',
  Omit<TypographyProps, 'color'> & VariantProps<typeof link>
>;

export type LinkProps = ComponentProps<Link>;

export const Link: Component<Link> = forwardRef(function Link(
  { children, className, color, underline, full, ...props },
  ref
) {
  return (
    <Typography
      as="a"
      ref={ref}
      {...props}
      className={cx(
        link({ color, full, underline }),
        className,
        props.intent ? undefined : 'font-size-inherit'
      )}
    >
      {children}
    </Typography>
  );
});
